import script from "./MaxPriorityFeePerGasSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaxPriorityFeePerGasSlider.vue?vue&type=script&setup=true&lang=ts"

import "./MaxPriorityFeePerGasSlider.vue?vue&type=style&index=0&id=4fd2ffc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd2ffc6"]])

export default __exports__